// # Significance Message Component for Financial Metrics
import React, { useState } from 'react';
import { FaQuestionCircle, FaTimes } from 'react-icons/fa';
import './significance_msg.css';

// # Significance messages for different financial metrics
const significanceMessages = {
  profitMargin: {
    title: "Profit Margin",
    description: "Profit Margin shows what percentage of revenue remains after all costs. Higher values indicate better profitability. A healthy business typically maintains 10-20% or higher."
  },
  
  burnRate: {
    title: "Burn Rate",
    description: "Burn Rate measures how quickly you're spending money relative to revenue. Lower values are better. If this exceeds 100%, you're spending more than you earn."
  },
  
  cashRunway: {
    title: "Cash Runway",
    description: "Cash Runway estimates how many months you can operate at current spending levels. Longer runways (6+ months) provide better financial security and planning flexibility."
  },
  
  revenueGrowth: {
    title: "Revenue Growth",
    description: "Revenue Growth tracks percentage increase in revenue over time. Positive values indicate business expansion. Consistent growth of 5-10% or more is generally considered healthy."
  },
  
  netRevenue: {
    title: "Net Revenue",
    description: "Net Revenue is your total income after budget allocations (5%). This is the 95% portion available for operations and team compensation."
  },
  
  budgetBalance: {
    title: "Budget Balance",
    description: "Budget Balance shows remaining funds in your 5% budget allocation after expenses. Positive values indicate sustainable expense management."
  },
  
  availableCash: {
    title: "Available Cash",
    description: "Available Cash represents net revenue (95%) minus salary deductions. This is the actual cash available for operations and future investments."
  }
};

// # Export function to get significance message by metric type
export const getSignificanceMessage = (metricType) => {
  return significanceMessages[metricType] || {
    title: "Metric Information",
    description: "No description available for this metric."
  };
};

const SignificanceMsg = ({ metricType }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const messageData = significanceMessages[metricType] || {
    title: "Metric Information",
    description: "No description available for this metric."
  };

  return (
    <>
      <span className="sig_msg_container">
        <FaQuestionCircle 
          className="sig_msg_icon"
          onClick={() => setIsOpen(true)}
        />
      </span>

      {isOpen && (
        <div className="sig_msg_modal">
          <div 
            className="sig_msg_overlay" 
            onClick={() => setIsOpen(false)} 
          />
          <div className="sig_msg_box">
            <button 
              className="sig_msg_close"
              onClick={() => setIsOpen(false)}
            >
              <FaTimes />
            </button>
            <div className="sig_msg_header">
              {messageData.title}
            </div>
            <div className="sig_msg_content">
              {messageData.description}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignificanceMsg;
